import { cx, Icon, Link, OverflowableText } from 'leanplum-lib-ui';
import Vue, { VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

require('./SingleColumnLayout.scss');

@Component({ name: 'SingleColumnLayout' })
class SingleColumnLayout extends Vue {
  private static readonly SCROLL_TOP_OFFSET: number = 48;

  @Prop({ type: String, required: true })
  readonly title: string;

  @Prop({ type: String, required: false, default: null })
  readonly titleClassName: string | null;

  @Prop({ type: Object, required: false, default: null })
  readonly backLink: Link.Props;

  readonly $slots: {
    actions: Array<VNode>;
    subtitle: Array<VNode>;
    default: Array<VNode>;
    infoPanel: Array<VNode>;
  };

  private isPageScrolled: boolean = false;

  render(): VNode {
    return (
      <div class="page-container" onScroll={this.onScroll}>
        <div class={cx('header-wrapper', { scrolled: this.isPageScrolled })}>
          <div class="header-content">
            <div class="link-placeholder">
              {this.backLink && (
                <Link {...{ props: this.backLink }} icon={Icon.Type.ARROW_LEFT} onClick={this.emitBack} />
              )}
            </div>
            <div class="header-title">
              <OverflowableText class={cx('page-title', this.titleClassName)} text={this.title} />
              {this.$slots.subtitle}
              {this.$slots.infoPanel && <section class="info-panel">{this.$slots.infoPanel}</section>}
              <section class={cx('actions', { 'with-left-margin': !this.$slots.infoPanel })}>
                {this.$slots.actions}
              </section>
            </div>
          </div>
        </div>
        <div class="page-content">{this.$slots.default}</div>
      </div>
    );
  }

  private onScroll(event: UIEvent): void {
    const target = event.target as HTMLDivElement;
    this.isPageScrolled = target.scrollTop > SingleColumnLayout.SCROLL_TOP_OFFSET;
  }

  private emitBack(event: Event): void {
    this.$emit('back', event);
  }
}

export { SingleColumnLayout };
